import { render, staticRenderFns } from "./SuccessfulPayment.vue?vue&type=template&id=56eab276&scoped=true&"
import script from "./SuccessfulPayment.vue?vue&type=script&lang=js&"
export * from "./SuccessfulPayment.vue?vue&type=script&lang=js&"
import style0 from "./SuccessfulPayment.vue?vue&type=style&index=0&id=56eab276&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eab276",
  null
  
)

export default component.exports